import type { LucideIcon } from "lucide-react";
import {
  Building2,
  Crosshair,
  FileCheck2,
  Globe2,
  ListTodo,
  MapPinned,
  MessageSquare,
  ShieldEllipsis,
} from "lucide-react";
import type { ModuleFeatureFlags } from "@/lib/feature-flags";
import { envFeatureFlags } from "@/lib/feature-flags";

export type ModuleCode =
  | "oi"
  | "rd"
  | "go"
  | "udgspz"
  | "work-items"
  | "visualizer"
  | "tactical"
  | "chat";

export interface ModuleRegistryItem {
  code: ModuleCode;
  label: string;
  /** Короткая подпись назначения модуля для launcher. */
  description: string;
  route: string;
  icon: LucideIcon;
  searchPlaceholder?: string;
  requiredPermission?: string;
  enabled: boolean;
}

export function getModuleRegistry(flags: ModuleFeatureFlags = envFeatureFlags): ModuleRegistryItem[] {
  return [
    {
      code: "oi",
      label: "Объекты",
      description: "Реестр объектов инфраструктуры и карта",
      route: "/oi",
      icon: Building2,
      searchPlaceholder: "Поиск по системе…",
      requiredPermission: "objects.view",
      enabled: flags.moduleOiEnabled,
    },
    {
      code: "rd",
      label: "Согласования",
      description: "Заявки и согласование размещения",
      route: "/rd",
      icon: FileCheck2,
      searchPlaceholder: "Поиск по системе…",
      requiredPermission: "rd.view",
      enabled: flags.moduleRdEnabled,
    },
    {
      code: "go",
      label: "Географический обзор",
      description: "Страны, регионы и геоконтекст",
      route: "/go",
      icon: Globe2,
      searchPlaceholder: "Поиск по системе…",
      requiredPermission: "go.view",
      enabled: flags.moduleGoEnabled,
    },
    {
      code: "udgspz",
      label: "Геостратегическое зонирование",
      description: "Зоны и геостратегическое планирование",
      route: "/udgspz",
      icon: ShieldEllipsis,
      searchPlaceholder: "Поиск по системе…",
      requiredPermission: "udgspz.view",
      enabled: flags.moduleUdgspzEnabled,
    },
    {
      code: "visualizer",
      label: "Визуализатор",
      description: "Сцены и знаки на карте",
      route: "/visualizer",
      icon: MapPinned,
      searchPlaceholder: "Поиск по системе…",
      requiredPermission: "visualizer.view",
      enabled: flags.moduleVisualizerEnabled,
    },
    {
      code: "tactical",
      label: "Тактическая обстановка",
      description: "Доски обстановки и тактические объекты",
      route: "/tactical",
      icon: Crosshair,
      searchPlaceholder: "Поиск по системе…",
      requiredPermission: "tactical.view",
      enabled: flags.moduleTacticalEnabled,
    },
    {
      code: "work-items",
      label: "Задачи и инциденты",
      description: "Задачи операторов и инциденты",
      route: "/work-items",
      icon: ListTodo,
      searchPlaceholder: "Поиск по системе…",
      requiredPermission: "work_items.view",
      enabled: flags.workItemsUiEnabled,
    },
    {
      code: "chat",
      label: "Чат",
      description: "Личные и групповые чаты со сквозным шифрованием",
      route: "/chat",
      icon: MessageSquare,
      searchPlaceholder: "Поиск по чатам…",
      requiredPermission: "chat.use",
      enabled: flags.moduleChatEnabled,
    },
  ];
}

/** Статический снимок на env-fallback (для мест без React context). */
export const moduleRegistry = getModuleRegistry(envFeatureFlags);
